// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"2a99a1da","213":"d8bc715f","825":"3bd8d428","850":"46c3ca06","908":"5345e220"}[chunkId] + ".chunk.css";
};